import type { RouteObject } from 'react-router';

import * as searchJobsHorizonRouteExports from '#/modules/search/jobs/page/SearchJobs.horizon-route';
import { horizonRouteToObject } from '#/routing/utils/horizonRouteToObject';

import { searchJobsRoutePaths } from './searchJobs.route-paths';

const searchJobsRouteObject = horizonRouteToObject(
  searchJobsHorizonRouteExports,
);
const createSearchJobsRouteObject = (path: string): RouteObject => ({
  path,
  ...searchJobsRouteObject,
});

export const searchJobsRouteObjects = searchJobsRoutePaths.map(
  createSearchJobsRouteObject,
);
